import React from 'react';

import {BlockSkeleton} from '@udemy/react-reveal-components';

import styles from './personal-plan-comparison-skeleton.module.less';

/** Sized shell that forces BlockSkeleton to fill its parent (default is 4.8rem wide). */
const SkeletonBlock = ({className}: {className: string}) => (
    <div className={className}>
        <BlockSkeleton className={styles['fill']} />
    </div>
);

/**
 * ### PersonalPlanComparisonSkeleton
 *
 * Loading state for the plan comparison section. Renders one heading placeholder
 * and two card-shaped blocks that mirror the Personal Plan + marketplace cards layout.
 */
export const PersonalPlanComparisonSkeleton = () => {
    return (
        <div className={styles['wrapper']} data-testid="personal-plan-comparison-skeleton">
            <div className="ud-container">
                <SkeletonBlock className={styles['heading']} />
                <div
                    className={styles['cards']}
                    data-testid="personal-plan-comparison-skeleton-cards"
                >
                    <SkeletonBlock className={styles['card']} />
                    <SkeletonBlock className={styles['card']} />
                </div>
            </div>
        </div>
    );
};
